/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    getUserRole,
    SaveUserRole,
    GetOperationEntityDetailsDetailsByOperationEntityID,
    EditUserRole,
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetProductCategoties,
    GetProductDetails,
    GetAllProductsDetails,
    GetAllFactoriesByFactoryType,
    GetSpecialProductCategotiesForDropDown,
    GetAllProductsDetailsByProductSpecialProduct
};

async function getUserRole(groupID, operationEntityID, level) {
    const response = await CommonGet('/api/Role/GetRolesByRoleLevel', 'roleLevelID=' + parseInt(level) + '&groupID=' + parseInt(groupID) + '&operationEntityID=' + parseInt(operationEntityID));
    if (response.data != null) {
        return response.data;
    }
    return null;
}

async function GetOperationEntityDetailsDetailsByOperationEntityID(id) {
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityDetailsDetailsByOperationEntityID', 'OperationEntityID=' + parseInt(id));
    if (response.data != null) {
        return response.data;
    }
    return null;
}

async function SaveUserRole(values) {

    const response = await CommonPost('/api/OperationEntity/SaveOperationEntity', null, values);
    return response;

}

async function EditUserRole(values) {

    const response = await CommonPost('/api/OperationEntity/UpdateOperationEntity', null, values);
    return response;

}

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllProductsDetails() {
    const response = await CommonGet('/api/Product/GetAllProductsDetails', null);
    return response.data;
}

async function GetAllProductsDetailsByProductSpecialProduct(productCategoryID, specialProductCategoryID) {
    const response = await CommonGet('/api/Product/GetAllProductsDetailsByProductSpecialProduct', 'productCategoryID=' + parseInt(productCategoryID) + '&specialProductCategoryID=' + specialProductCategoryID);
    return response.data;
}

async function GetAllFactoriesByFactoryType(groupID, operationEntityTypeID) {
    const response = await CommonGet('/api/OperationEntity/GetAllFactoriesByFactoryType', 'groupID=' + parseInt(groupID) + '&factoryType=' + operationEntityTypeID);
    return response.data;
}

async function GetSpecialProductCategotiesForDropDown() {
    const response = await CommonGet('/api/SpecialProductCategory/GetSpecialProductCategoryDetailsForDropDown', null);
    return response.data;
}


